import { AntragUpdateDto } from '../dto/antrag-update';
import { GenericDtoAssemblerService } from '@ebeihilfe/core';
import { Injectable, inject } from '@angular/core';
import { MetadataHelpersService } from '../services';
import { PartiallyTypedNewAntrag } from '../model';

@Injectable({
  providedIn: 'root',
})
export class AntragUpdateDtoAssemblerService extends GenericDtoAssemblerService<
  PartiallyTypedNewAntrag,
  AntragUpdateDto
> {
  private readonly metadataHelpersService = inject(MetadataHelpersService);

  public override async toDto(entity: PartiallyTypedNewAntrag): Promise<AntragUpdateDto> {
    const encryptedMetadata = await this.metadataHelpersService.serialize(entity.metadata);

    return new AntragUpdateDto(entity.antragId, entity.concurrency, encryptedMetadata);
  }

  public override async fromDto(dto: AntragUpdateDto): Promise<PartiallyTypedNewAntrag> {
    const decryptedMetadata = await this.metadataHelpersService.deserialize(dto.encryptedMetadata);

    return new PartiallyTypedNewAntrag(dto.antragId, dto.concurrency, decryptedMetadata);
  }
}
